import React from 'react';
import classnames from 'classnames';
import ArtStageArrowL from '../../../Icons/ArtStageArrowL';
import ArtStageArrowR from '../../../Icons/ArtStageArrowR';
import { BiEventType } from '../../../biLogger';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import BackToStreamButton from '../BackToStreamButton';
import { DuperbrowsePaddle } from './DuperbrowsePaddle';
import { useDuperbrowseKeyboardNavigation } from '../../../Duperbrowse/hooks/useDuperbrowseKeyboardNavigation';
import s from './DuperbrowsePaddles.scss';
export function getBiEventData(deviation, direction, streamItem) {
    return {
        evid: BiEventType.NAVIGATION_ARROW_CLICK,
        itemid: deviation.deviationId,
        direction: direction,
        next_itemid: streamItem && streamItem.deviationId,
        typeid: getDeviationResourceType(deviation),
    };
}
var DuperbrowsePaddles = function (_a) {
    var className = _a.className, isDuperbrowseActive = _a.isDuperbrowseActive, enableKeyboardNavigation = _a.enableKeyboardNavigation, _b = _a.navigation, nextItem = _b.nextItem, prevItem = _b.prevItem, deviation = _a.deviation, moveNext = _a.moveNext, movePrev = _a.movePrev;
    useDuperbrowseKeyboardNavigation({
        isDuperbrowseActive: isDuperbrowseActive,
        enableKeyboardNavigation: enableKeyboardNavigation,
        moveNext: moveNext,
        movePrev: movePrev,
        getBiEventData: getBiEventData,
        fromItem: deviation,
        nextItem: nextItem,
        prevItem: prevItem,
    });
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(DuperbrowsePaddle, { isEnabled: !!prevItem, className: s['prev'], onClick: movePrev, dataHook: "arrowL" },
            React.createElement(ArtStageArrowL, { customSizable: true, className: s.icon })),
        React.createElement(BackToStreamButton, { deviation: deviation }),
        React.createElement(DuperbrowsePaddle, { isEnabled: !!nextItem, className: s['next'], onClick: moveNext, dataHook: "arrowR" },
            React.createElement(ArtStageArrowR, { customSizable: true, className: s.icon }))));
};
export default DuperbrowsePaddles;
//# sourceMappingURL=DuperbrowsePaddles.js.map